import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { ReactElement, useState } from "react";
import { Base } from ".";
import { ExpandMore } from "@mui/icons-material";

interface Props {
  title: string;
  content: ReactElement;
  alwaysAccordion?: boolean;
  expanded?: boolean;
  backgroundColor?: string;
  badgeNumber?: number;
  color?: string;
  innerAccordion?: boolean;
  onChange?: ((event: React.SyntheticEvent, expanded: boolean) => void)
}

const AccordionContainer: React.FC<Props> = (props) => {
  const {
    title,
    content,
    alwaysAccordion,
    expanded,
    backgroundColor,
    innerAccordion,
    onChange
  } = props;
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("md"));
  const [expand, setExpand] = useState(!!expanded);
  return (
    <>
      {sm || alwaysAccordion ? (
        <Accordion
          disableGutters
          expanded={onChange ? expanded : expand}
          elevation={0}
          onChange={(event, expanded) => {
            if(onChange){
              onChange?.(event, expanded)
            } else{
              setExpand(!expand);
            }
          }}
          sx={{ backgroundColor: backgroundColor ?? theme.palette.background.default }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              "& .MuiAccordionSummary-root": {
                minHeight: "50px",
              },
              "& .Mui-expanded": {
                marginY: "0px",
              },
              "& .MuiAccordionSummary-content": {
                marginY: "0px",
              },
              wordWrap: "break-word",
            }}
          >
            <Typography>
              <Base.Badge {...props}>
                <Base.Text
                  text={title}
                  variant={innerAccordion ? undefined : "h3"}
                  component="span"
                />
              </Base.Badge>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{content}</AccordionDetails>
        </Accordion>
      ) : (
        <>{content}</>
      )}
    </>
  );
};

export default AccordionContainer;
